// Components==============
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import './ExpendMenuItem.module.scss';
// =========================

export default function ExpandMenuItem({
  title,
  component,
  hideArrow,
}: {
  title: string;
  component: React.ReactNode;
  hideArrow?: boolean;
}) {
  const [expanded, setExpanded] = useState(true);

  return (
    <div styleName="grid">
      <div onClick={() => setExpanded((prev) => !prev)} styleName="wrapper">
        <h4>{title}</h4>
        {!hideArrow && (
          <FontAwesomeIcon
            styleName={`${expanded ? '' : 'rotated'}`}
            icon={faChevronUp}
          />
        )}
      </div>
      {expanded && component}
    </div>
  );
}
